import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Link } from "react-router-dom";


function Notification(props) {

    const content = JSON.parse(props.content);
    const [show, setShow] = React.useState(true);

    function editNotification(idNotification, boolean) {
        fetch(`${props.url}/procesos-api/edit-notifications`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token '+ localStorage.getItem('token'),
            },
            token: localStorage.getItem('token'),
            body: JSON.stringify({idNotification: idNotification,
                                  delete: boolean
            }),
            delete: boolean
        })
        .then(setShow(false))
    }

    return(
        <Grid item xs={12} md={12} lg={12} xl={12}>
            {show ?
            <Card>
                <CardContent>
                    <Typography variant="h5" component="div" onClick={() => editNotification(content.pk, true)}>
                        {content.alerta ? <span className="material-icons-round task-icon unchecked">notifications</span> 
                        : <span className="material-icons-round task-icon checked">notifications</span>}
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} color="text.primary" gutterBottom>
                        <div className='bold'>{content.fecha}</div>
                    </Typography>
                    <br></br>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                        {content.contenido}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Link id="notification-button" to={`/proceso/${content.proceso_cpnu_id}`} className="no-link">
                        <Button size="small" onClick={() => editNotification(content.pk, false)}>Ver</Button>
                    </Link>
                </CardActions>
            </Card> : null
            }
        </Grid>
    )
}

export { Notification };